import React, { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import { 
    CheckCircle as CheckCircleIcon,
    Cancel as CancelIcon,
    Edit as EditIcon 
} from '@material-ui/icons';
import { ClaimStatus } from '../../Models/Property';

interface RenderDocumentActionsProps {
    doc: any;  // Replace with your document type
    classes: any;
    handleAccept: (id: number) => void;
    handleReject: (id: number) => void;
    isUpdatingStatus: boolean;
    userState: any;
}

export default function RenderDocumentActions(props: RenderDocumentActionsProps){

    const [showButtons, setShowButtons] = useState(false);
    const canEdit = props.userState.user.category === 1;

    const toggleButtons = () => {
        setShowButtons(!showButtons);
    };

    const ReadOnlyStatus = () => {
        switch (props.doc.status) {
            case ClaimStatus.Pending:
                return <Typography>Pending Review</Typography>;
            case ClaimStatus.Accepted:
                return (
                    <Typography className={props.classes.acceptedText}>
                        Accepted
                        <CheckCircleIcon className={props.classes.statusIcon} />
                    </Typography>
                );
            case ClaimStatus.Rejected:
                return (
                    <Typography className={props.classes.rejectedText}>
                        Rejected
                        <CancelIcon className={props.classes.statusIcon} />
                    </Typography>
                );
            default:
                return null;
        }
    };

    if (!canEdit) {
        return <ReadOnlyStatus />;
    }
    
    switch (props.doc.status) {
        case ClaimStatus.Pending:
            return (
                <>
                    <Button
                        variant="contained"
                        size="small"
                        className={props.classes.acceptButton}
                        onClick={() => props.handleAccept(props.doc.internalId)}
                        disabled={props.isUpdatingStatus}
                    >
                        Accept
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        className={props.classes.rejectButton}
                        onClick={() => props.handleReject(props.doc.internalId)}
                        disabled={props.isUpdatingStatus}
                    >
                        Reject
                    </Button>
                </>
            );
        case ClaimStatus.Accepted:
            return (
                <div className={props.classes.statusContainer}>
                    {showButtons ? (
                        <Button
                            variant="contained"
                            size="small"
                            className={props.classes.rejectButton}
                            onClick={() => {
                                props.handleReject(props.doc.internalId);
                                setShowButtons(false);
                            }}
                            disabled={props.isUpdatingStatus}
                        >
                            Change to Rejected
                        </Button>
                    ) : (
                        <>
                            <Typography className={props.classes.acceptedText}>
                                Accepted
                                <CheckCircleIcon className={props.classes.statusIcon} />
                            </Typography>
                            <EditIcon className={props.classes.editIcon} onClick={toggleButtons} />
                        </>
                    )}
                </div>
            );
        case ClaimStatus.Rejected:
            return (
                <div className={props.classes.statusContainer}>
                    {showButtons ? (
                        <Button
                            variant="contained"
                            size="small"
                            className={props.classes.acceptButton}
                            onClick={() => {
                                props.handleAccept(props.doc.internalId);
                                setShowButtons(false);
                            }}
                            disabled={props.isUpdatingStatus}
                        >
                            Change to Accepted
                        </Button>
                    ) : (
                        <>
                            <Typography className={props.classes.rejectedText}>
                                Rejected
                                <CancelIcon className={props.classes.statusIcon} />
                            </Typography>
                            <EditIcon className={props.classes.editIcon} onClick={toggleButtons} />
                        </>
                    )}
                </div>
            );
        default:
            return null;
    }
};